export const toastrSettings = {
    style: {
        borderRadius: '8px',
        background: '#222222',
        color: '#fff',
        marginRight: '0.5rem'
    },
};
